import type {
  AddLearningTimeV2Data,
  SearchArticlesReq,
  SearchResult
} from '@/models/interface/reading';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class ReadingService extends ApiFactory {
  constructor() {
    super('Read');
  }

  getSearchArticles(params: SearchArticlesReq): Promise<ApiDataResponse<SearchResult>> {
    return this.post('SearchArticles', params);
  }

  addLearningTimeV2(params: AddLearningTimeV2Data): Promise<ApiDataResponse<boolean>> {
    return this.post('AddLearningTimeV2', params, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }

  /**
   * 取得文章的 PDF 檔
   * @param articleId - 文章 ID
   */
  getArticlePdf(articleId: number): Promise<ApiDataResponse<string>> {
    return super.get(`GetPdf/${articleId}`, null, {
      headers: {
        'Content-Type': 'application/json',
        disableGlobalLoading: true
      }
    });
  }
}
